import Grid from '@material-ui/core/Grid';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import FieldText from 'components/Field/Text';
import Translate from 'components/Translate';
import { enProductType } from 'enums/enProductType';
import { IStuddentModel } from 'interfaces/ICartModel';
import { IProductData, enCurrency } from 'interfaces/IProductData';
import React from 'react';
import { cartService } from 'services/CartService';
import { parameterService } from 'services/ParameterService';
import { paymentService } from 'services/PaymentService';

import SuggestEmail from '../UserForm/SuggestEmail';
import { currencyService } from 'services/CurrencyService';

interface IState extends IStateBase {
  model: IStuddentModel;
  currency: enCurrency;
  suggest: boolean;
  cart: IProductData;
  lock: boolean;
  showDocument: string;
  personType: string;
}

export default class StuddentForm extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      suggest: false,
      currency: undefined,
      cart: undefined,
      model: undefined,
      lock: false,
      showDocument: '0',
      personType: ''
    };
  }

  componentDidMount() {
    this.bindModel(paymentService.getCart().map(c => c.studdent || {}));
    this.observeState({ currency: null }, currencyService.getCurrency());
    this.observeState({ cart: null }, cartService.getCart());

    cartService
      .getCart()
      .bindComponent(this)
      .filter(cart => !!cart.user)
      .map(cart => cart.user.lock)
      .subscribe(lock => {
        this.setState({ lock });
      });

    paymentService
      .getCart()
      .bindComponent(this)
      .subscribe(cart => this.setState({ personType: cart.personType }));

    parameterService
      .getAll()
      .bindComponent(this)
      .subscribe(params => {
        this.setState({ showDocument: params.sdoc });
      });
  }

  componentDidUpdate() {
    if (this.state.formSubmitted != this.props.formSubmitted) {
      this.setState({ formSubmitted: this.props.formSubmitted });
    }
  }

  autoSuggest = (email: any) => {
    this.setState({ suggest: email.includes('@') });
  };

  autoComplete = (value: any) => {
    const email = `${this.state.model.email.split('@')[0]}${value}`;

    paymentService.setStuddentData({ email });
    this.setState({ suggest: false });
  };

  disableSuggest = () => {
    setTimeout(() => this.setState({ suggest: false }), 300);
  };

  setEmail = (email: any) => {
    this.autoSuggest(email);
    paymentService.setStuddentData({ email });
  };

  setPhone = (phone: any) => {
    paymentService.setStuddentData({ phone });
  };

  setName = (name: any) => {
    paymentService.setStuddentData({ name });
  };

  setDocument = (document: any) => {
    paymentService.setStuddentData({ document });
  };

  render() {
    if (!this.state.model) {
      return <div />;
    }

    const { cart, lock, personType } = this.state;
    const model = this.state.model || {};

    return (
      <div className="chk-user-form">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FieldText
              id="name"
              disabled={lock}
              label={<Translate term="Nome Completo do Aluno" />}
              validation="required|name|max:100"
              value={model.name}
              onChange={this.setName}
              inputProps={{
                className: `theme-input ${lock ? 'disabledField' : ''}`
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-name'
              }}
            />
          </Grid>

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <div className="tooltip-email-information">
              <FieldText
                id="email"
                disabled={lock}
                label={<Translate term="E-mail do Aluno" />}
                validation="required|email|max:150"
                value={model.email}
                type="email"
                mask="nospace"
                onChange={this.setEmail}
                onBlur={this.disableSuggest}
                inputProps={{
                  className: `theme-input ${lock ? 'disabledField' : ''}`
                }}
                InputLabelProps={{
                  className: 'theme-label',
                  id: 'label-email'
                }}
              />
              {this.state.suggest && <SuggestEmail email={model.email.split('@')[1]} autoComplete={this.autoComplete} />}
            </div>
          </Grid>

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <FieldText
              id="cellphone"
              disabled={lock}
              label={<Translate term="Celular do Aluno" />}
              validation={personType != 'E' ? 'required|min:10|max:11' : 'required|min:3|max:36'}
              value={model.phone}
              mask={personType != 'E' ? 'phone' : null}
              type="tel"
              onChange={this.setPhone}
              inputProps={{
                className: `theme-input ${lock ? 'disabledField' : ''}`
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-phone'
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FieldText
              id="document"
              disabled={lock}
              label={<Translate term={personType != 'E' ? 'CPF do Aluno' : 'Document ID / VAT / TAX ID'} />}
              validation={personType != 'E' ? 'required|cpf' : 'required|min:3|max:32'}
              value={model.document}
              mask={personType != 'E' ? 'cpf' : null}
              inputProps={{
                className: `theme-input ${lock ? 'disabledField' : ''}`,
                pattern: '[0-9]*',
                inputMode: 'numeric',
                type: 'tel'
              }}
              InputLabelProps={{
                className: 'theme-label'
              }}
              onChange={this.setDocument}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}
